import React from "react";
import {
	Control,
	FieldValues,
	useFieldArray,
	UseFormGetValues,
	UseFormRegister,
	UseFormSetValue,
} from "react-hook-form";
import { changeLanguage } from "../../components/I18N/TranslateHelpers";
import { GetCurrentLocale } from "../../components/Utils";
import { store } from "app/store";
import { getAgreementsList } from "features/Slice/AgreementSlice";
import { useSelector } from "react-redux";
import { RootState } from "app/RootReducer";
import { SpinnerOnTop } from "components/SpinnerOnTop";
import { getCurrentAppForm } from "features/Slice/ApplicationFormSlice";
import AgreementUploadField from "components/Forms/AgreementUploadField";
import t from "../../components/I18N/TranslateHelpers";

interface ComponentProps {
	applicationFormId: string;
	applicationFormCultureCode: string;
	register: UseFormRegister<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
	getValues: UseFormGetValues<FieldValues>;
	isReadOnly: boolean;
	sectionId: number;
	control: Control<FieldValues, any>,
}

const ApplicantAgreementForm: React.FC<ComponentProps> = ({
	applicationFormId,
	applicationFormCultureCode,
	register,
	setValue,
	getValues,
	isReadOnly,
	sectionId,
	control
}) => {
	const isRequestingAgreementList = useSelector((state: RootState) => state.agreementRdc.isRequestingList);
	const agreementList = useSelector((state: RootState) => state.agreementRdc.agreementsList);
	const isPostSuccess = useSelector((state: RootState) => state.agreementRdc.isPostSuccess);

	React.useEffect(() => {
		const locale = GetCurrentLocale();
		changeLanguage(locale);

		store.dispatch(getAgreementsList(applicationFormId));
	}, []);

	React.useEffect(() => {
		if (isPostSuccess) {
			store.dispatch(getCurrentAppForm(applicationFormId, true));
		}
	}, [isPostSuccess]);
	
	return (
		isRequestingAgreementList || !agreementList ?
			<SpinnerOnTop />
			:
				<div className="mb-3 container-agreement col-md-12">
					<div className="card">
						<div className="card-header">
							<h5 className="mb-0 pl-0">{t('agreements')}</h5>
						</div>
						<div className="col-md-12 col-sm-12 nopadding">
							<div className="card-body">
								<ul id="todo-list">
									{agreementList.map((agreement, index) => {
										return (
											<AgreementUploadField
												agreement={agreement}
												applicationFormCultureCode={applicationFormCultureCode}
												applicationFormId={applicationFormId}
												getValues={getValues}
												index={index}
												isReadOnly={isReadOnly}
												register={register}
												setValue={setValue}
												key={agreement.agreementUID}
												sectionId={sectionId}
												control={control}
											/>
										)
									}
									)}

								</ul>
							</div>
						</div>
					</div>
				</div>
	);
};

export default ApplicantAgreementForm;
